var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360.241 384.596-213.365-.031c-5.885 0-10.667 4.771-10.667 10.667 0 5.885 4.771 10.667 10.667 10.667l213.365.031c5.885 0 10.667-4.771 10.667-10.667-.001-5.886-4.771-10.667-10.667-10.667zM317.543 427.263h-128a10.66 10.66 0 0 0-10.667 10.667 10.66 10.66 0 0 0 10.667 10.667h128a10.66 10.66 0 0 0 10.667-10.667 10.66 10.66 0 0 0-10.667-10.667zM256.001 128.002c-64.698 0-117.333 52.635-117.333 117.333s52.635 117.333 117.333 117.333 117.333-52.635 117.333-117.333-52.635-117.333-117.333-117.333zm-94.922 128h41.807c1.181 29.056 7.182 57.952 17.599 78.342-32.169-12.883-55.394-42.679-59.406-78.342zm41.808-21.333H161.08c4.012-35.663 27.237-65.458 59.406-78.342-10.417 20.39-16.418 49.286-17.599 78.342zm53.114 106.667c-12.221 0-29.409-33.047-31.573-85.333h63.146c-2.164 52.286-19.352 85.333-31.573 85.333zm-31.573-106.667c2.164-52.286 19.352-85.333 31.573-85.333s29.409 33.047 31.573 85.333h-63.146zm67.089 99.676c10.417-20.391 16.418-49.286 17.599-78.342h41.807c-4.012 35.662-27.237 65.458-59.406 78.342zm17.599-99.676c-1.181-29.056-7.182-57.952-17.599-78.342 32.169 12.884 55.395 42.68 59.406 78.342h-41.807z",
    fill: "#898686",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.334 64.002h-21.333V41.96c0-23.306-19.721-42.193-42.667-41.958-3.278.034-6.147.488-9.531 1.344l-227.42 62.887c-22.452 1.216-40.382 19.688-40.382 42.436v362.667c0 23.531 19.135 42.667 42.667 42.667h298.667c23.531 0 42.667-19.135 42.667-42.667V106.669c-.001-23.531-19.136-42.667-42.668-42.667zM337.282 21.96c12.448-3.177 25.385 6.906 25.385 20v22.042H185.259L337.282 21.96zm89.386 447.376c0 11.76-9.573 21.333-21.333 21.333H106.668c-11.76 0-21.333-9.573-21.333-21.333V106.669c0-11.76 9.573-21.333 21.333-21.333h298.667c11.76 0 21.333 9.573 21.333 21.333v362.667z",
    fill: "#898686",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.9891715665935b3404558305995da66e.svg";
export { ForwardRef as ReactComponent };